import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-authorized',
  templateUrl: './no-authorized.component.html',
  styleUrls: ['./no-authorized.component.scss']
})
export class NoAuthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
